// --------------home testimonial
window.addEventListener('load', (event) => {
  
  window.dispatchEvent(new Event('resize'));
  if(jQuery('.testimonialCarousel').length > 0) {


    if(!jQuery('.testimonialCarousel').hasClass('slick-initialized')){
      jQuery('.testimonialCarousel').slick({
        dots: true,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.testimonialImage-crousel',
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });

      jQuery('.testimonialCarousel').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        jQuery('.testimonialCarousel').attr('data-index', nextSlide)
      });

      jQuery('.testimonialImage-crousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        fade: true,
        asNavFor: '.testimonialCarousel'
      })
    }
  }
  //
  jQuery(".set > a").on("click", function(e) {
    e.preventDefault();
    if (jQuery(this).hasClass("active")) {
      jQuery(this).removeClass("active");
      jQuery(this)
      .siblings(".content")
      .slideUp(200);
      jQuery(".set > a i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
    } else {
      jQuery(".set > a i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
      jQuery(this)
      .find("i")
      .removeClass("fa-plus")
      .addClass("fa-minus");
      jQuery(".set > a").removeClass("active");
      jQuery(this).addClass("active");
      jQuery(".content").slideUp(200);
      jQuery(this)
      .siblings(".content")
      .slideDown(200);
    }
  });
  

  
  // TAg filters on collection page
  jQuery('.filters__select:not(.sort-position)').on('change', function(e){
    var value = jQuery(this).val();
    
    console.log("sdfsdf");

    if(value == 'link') {
      var link = jQuery('option:selected', this).attr('data-href');
      location.href=link;
      return;
    }

    var handle = collection_handle;
    var shop = shopURL;

    var typeValue = jQuery('.type-select').val();
    var applicationValue = jQuery('.application-select').val();
    var areaValue = jQuery('.area-select').val();
    var generateURL = '';
    
    if(typeValue == 0) {
      var allSelect = typeValue+','+applicationValue+','+areaValue;
    } else {
      var allSelect = applicationValue+','+areaValue;
      handle = typeValue;
    }

    


    var array = allSelect.split(',');
    var itemsProcessed = 0;
    array.forEach(function(item, index){
      itemsProcessed++;
      if(item != 0) {
        generateURL += item+'+'
      }
      if(itemsProcessed === array.length) {
        callback();
      }
    });
    function callback () {
      generateURL = generateURL.substring(0, generateURL.length - 1);
//       console.log(generateURL);
      
//       console.log('shopURL',shopURL);
//       console.log('handle',handle);
//       console.log('generateURL',generateURL);
      
      
      window.location.href = shopURL+'/collections/'+handle+'/'+generateURL;
    }

  })
});



// Purifer Find
jQuery(document).ready(function(){
  jQuery("#warrfiles").change(function(){
    var selectedOpt = jQuery(this).children("option:selected").val();
    jQuery(this).siblings(":last").children().addClass("view-agg").removeClass("agg-display");
    jQuery("#trg").find("#agg" + selectedOpt).addClass("agg-display").removeClass("view-agg ");
    console.log(selectedOpt);
  });

  jQuery(".bundles-cta__btn").on('click', function () {  //  here jQuery(this) is refering to document
    jQuery(".bundles-cta__btn").removeClass('active-medify');
    jQuery(this).addClass('active-medify');
  });


  jQuery(".living-room-btn").on('click', function () {  //  here jQuery(this) is refering to document
    jQuery(".tabcat-1").addClass('active-filter');
    jQuery(".tabcat-2").addClass('inactive-filter');
    jQuery(".tabcat-3").addClass('inactive-filter');
    jQuery(".tabcat-4").addClass('inactive-filter');
    jQuery(".tabcat-2").removeClass('active-filter');
    jQuery(".tabcat-3").removeClass('active-filter');
    jQuery(".tabcat-4").removeClass('active-filter');
    jQuery(".tabcat-1").removeClass('inactive-filter');
  });

  jQuery(".bedroom-btn").on('click', function () {  //  here jQuery(this) is refering to document
    jQuery(".tabcat-2").addClass('active-filter');
    jQuery(".tabcat-1").addClass('inactive-filter');
    jQuery(".tabcat-3").addClass('inactive-filter');
    jQuery(".tabcat-4").addClass('inactive-filter');
    jQuery(".tabcat-1").removeClass('active-filter');
    jQuery(".tabcat-3").removeClass('active-filter');
    jQuery(".tabcat-4").removeClass('active-filter');
    jQuery(".tabcat-2").removeClass('inactive-filter');
  });

  jQuery(".kitchen-btn").on('click', function () {  //  here jQuery(this) is refering to document
    jQuery(".tabcat-3").addClass('active-filter');
    jQuery(".tabcat-2").addClass('inactive-filter');
    jQuery(".tabcat-1").addClass('inactive-filter');
    jQuery(".tabcat-4").addClass('inactive-filter');
    jQuery(".tabcat-2").removeClass('active-filter');
    jQuery(".tabcat-1").removeClass('active-filter');
    jQuery(".tabcat-4").removeClass('active-filter');
    jQuery(".tabcat-3").removeClass('inactive-filter');
  });

  jQuery(".bathroom-btn").on('click', function () {  //  here jQuery(this) is refering to document
    jQuery(".tabcat-4").addClass('active-filter');
    jQuery(".tabcat-2").addClass('inactive-filter');
    jQuery(".tabcat-3").addClass('inactive-filter');
    jQuery(".tabcat-1").addClass('inactive-filter');
    jQuery(".tabcat-2").removeClass('active-filter');
    jQuery(".tabcat-3").removeClass('active-filter');
    jQuery(".tabcat-1").removeClass('active-filter');
    jQuery(".tabcat-4").removeClass('inactive-filter');
  });
  
  
  // Trigger Subscription widget for Filters pages
  if(jQuery('body').hasClass('filter-product')) {
    // ReCharge.buildWidget();
    // ReCharge.showWidget();
    // ReCharge.showAddToCartButton();
  }
  

  //filter help toggle
  jQuery(".filter-help h6").click(function(){
    jQuery(".filter-help_info").toggle();
    if(jQuery(this).text() == 'I NEED HELP CHOOSING MY FILTER'){
      jQuery(this).text('CLOSE FILTER INFORMATION PANEL').addClass('close-filter-help');
    } else {
      jQuery(this).text('I NEED HELP CHOOSING MY FILTER').removeClass('close-filter-help');
    }
  });

  jQuery(document).ready(function(){
    if(jQuery('body').hasClass('page_filterclub')) {
      jQuery('.rc_select__frequency').each(function(){
        jQuery(this).val('4');
      })
    }
  })
  
  
  
  // Call FAQs function
  faqSearch();
  
});






// Bussiness page Product Section Js Start
jQuery(document).ready(function() {
  if(jQuery('.business-product-section .row').length > 0) {
    jQuery('.business-product-section .row').slick({ 
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
    });
  }

  if(jQuery('#CollectionSidebar').length > 0) {
    var sidebarElem = document.getElementById("CollectionSidebar");
    sidebarElem.classList.remove("pointer-none");
  }
  
  jQuery('.sidebarToggle').on('click', function(e){
    if(jQuery(this).hasClass("enable")) {
      jQuery(this).find('.filter_status').html('Hide Filters');
      jQuery(this).removeClass('enable');
      jQuery(".collections__sidebar").removeClass('hide-sidebar');
      // jQuery('.collection-grid-buttons').find('[data-value="3"]').trigger('click');
    }else {
      jQuery(this).addClass('enable');
      jQuery(this).find('.filter_status').html('Show Filters');
      jQuery(".collections__sidebar").addClass('hide-sidebar');
      // jQuery('.collection-grid-buttons').find('[data-value="3"]').trigger('click');
    }
  })
  

  // jQuery(document).on("change", '[name="collection_link"]', function(){
    
  // });
  
  
  whyMedifyCadrTransiiton()
  
});

// Bussiness page Product Section Js End





function whyMedifyCadrTransiiton() {
  const $el = jQuery(".cadr-medify__img-wrapper");
  if ($el.length) {
    jQuery(window).scroll(function () {
      const elementTop = $el.offset().top;
      const elementHeight = $el.height();
      const screenTop = jQuery(window).scrollTop();
      const screenHeight = jQuery(window).height();
      const isElementCenterOnScreen =
        elementTop + elementHeight / 2 < screenTop + screenHeight / 2;
      if (isElementCenterOnScreen) {
        $el.addClass("cadr-medify__img-wrapper--animated");
      } else {
        $el.removeClass("cadr-medify__img-wrapper--animated");
      }
    });
  }
}


// FAQs Search
function faqSearch() {
  jQuery('.faq-search__input').parent('form').on('submit', function(e) {
    e.preventDefault();
  });

  jQuery('.faq-search__input').on('input', function() {
    let searchQuery = jQuery(this).val().toLowerCase().trim() // get the current value of the input field.
    if (searchQuery === '') {
      jQuery( ".faq-accordion .card" ).each(function() {
        jQuery(this).show()
        jQuery('.faq-accordion').show()
        jQuery('.faq-search__nav-list a').show()
      });
    } else {
      jQuery( ".faq-accordion .card" ).each(function() {
        jQuery(this).hide()
        if (jQuery(this).text().toLowerCase().indexOf(searchQuery) >= 0) {
          jQuery(this).show()
        }

        // HIDE accordion container (with heading) when all cards are hidden: 
        let isAllCardsHidden = (jQuery(this).css('display') == 'none');
        let accordionID = jQuery(this).parents('.faq-accordion').attr('id')
        jQuery(this).siblings().each(function() {
          if (jQuery(this).css('display') !== 'none') {
            isAllCardsHidden = false
          }
        });
        if (isAllCardsHidden) {
          jQuery(this).parents('.faq-accordion').hide()
          jQuery('.faq-search__nav-list a[href="#' + accordionID +'"]').hide()
        } else {
          jQuery('.faq-search__nav-list a[href="#' + accordionID +'"]').show()
          jQuery(this).parents('.faq-accordion').show()
        }
      });
    }
  });
}


// Warranty Agreement 
jQuery('#warrfiles').on('change', function(){
    var value = jQuery(this).val();
    jQuery('.view-agg').hide();
    jQuery('#agg'+value).show();
}); 


document.addEventListener('rebuy:cart.change', function () {
  // addToCartHandler.addItem(Rebuy.Cart.cart.items[0]);
  try{
    theme.Cart.updateCart(Rebuy.Cart.cart);
  } catch(err) {
    console.log(err);
  }
  
  // theme.Cart.addItem(Rebuy.Cart.cart.items[0]);
});

document.addEventListener('rebuy:cart.add', function(event){
  // theme.Cart.updateCart(Rebuy.Cart.cart);
}); 


document.addEventListener('rebuy.beforeAdd', function(event){ 
  event.detail.product.subscription_frequency = '4';
}); 

jQuery(document).on('keyup', '#message-9fb78c95-e141-49a6-aa0f-1c1edae9eea4', function(){
  var input = document.getElementById("message-9fb78c95-e141-49a6-aa0f-1c1edae9eea4");
  var submitButton = jQuery('#hsForm_9fb78c95-e141-49a6-aa0f-1c1edae9eea4').find('input[type="submit"]');
  if (input.value.length < 10) {
  submitButton.prop("disabled", true);
  } else {
  submitButton.prop("disabled", false);
  }
})

jQuery(document).on('keyup', '#message-73f76ba0-c4e5-42f1-abc0-086a0b43ad8a', function(){
  var input = document.getElementById("message-9fb78c95-e141-49a6-aa0f-1c1edae9eea4");
  var submitButton = jQuery('#hsForm_73f76ba0-c4e5-42f1-abc0-086a0b43ad8a').find('input[type="submit"]');
  if (input.value.length < 10) {
  submitButton.prop("disabled", true);
  } else {
  submitButton.prop("disabled", false);
  }
})


// Custom Scrollbar Js Start
// document.addEventListener("DOMContentLoaded", function() {
    
// });
// Custom Scrollbar Js End